type Listener = (online: boolean) => void;

const API_BASE = (import.meta.env.VITE_API_BASE_URL as string) || '';
const PROBE_PATH = '/api/health';
const PROBE_INTERVAL_MS = 60_000;
const PROBE_TIMEOUT_MS = 5_000;

class Connectivity {
  private online: boolean = navigator.onLine;
  private listeners = new Set<Listener>();
  private timer: number | null = null;

  constructor() {
    window.addEventListener('online', () => this.set(true));
    window.addEventListener('offline', () => this.set(false));
    this.startProbe();
  }

  isOnline(): boolean {
    return this.online;
  }

  /** Returns an unsubscribe function. */
  onStatusChange(cb: Listener): () => void {
    this.listeners.add(cb);
    return () => {
      this.listeners.delete(cb);
    };
  }

  private set(value: boolean): void {
    if (value === this.online) return;
    this.online = value;
    this.listeners.forEach((l) => l(value));
  }

  private startProbe(): void {
    if (this.timer !== null) return;
    this.timer = window.setInterval(() => void this.probe(), PROBE_INTERVAL_MS);
  }

  private async probe(): Promise<void> {
    try {
      const ctrl = new AbortController();
      const t = window.setTimeout(() => ctrl.abort(), PROBE_TIMEOUT_MS);
      const r = await fetch(`${API_BASE}${PROBE_PATH}`, {
        method: 'GET',
        signal: ctrl.signal,
        cache: 'no-store',
      });
      window.clearTimeout(t);
      this.set(r.ok);
    } catch {
      this.set(false);
    }
  }
}

export const connectivity = new Connectivity();
